// Copyright (c) 2026 Goffy. This file belongs to Goffy. All Rights Reserved.

/**
 * Kill switch for the app-wide BETA badge. The app is in beta in every environment today, so the
 * badge is on unless an environment explicitly turns it off — an unset variable in one of the env
 * files must fail towards "badge shows", never towards "badge silently vanished".
 *
 * Must stay a plain `process.env.EXPO_PUBLIC_X` member expression: babel-preset-expo only inlines
 * that exact form into native bundles, so optional-chaining or destructuring this would silently
 * read as undefined on device while still working on web.
 *
 * To retire the badge, set EXPO_PUBLIC_BETA_BADGE_DISABLED=true in the matching env file
 * (app.config.js picks `.env.<platform>.<nodeEnv>`, then `.env.<nodeEnv>`, then `.env`).
 */
export function isBetaBadgeEnabled(): boolean {
  return process.env.EXPO_PUBLIC_BETA_BADGE_DISABLED !== 'true';
}
